<div class="level-dialog" [ngClass]="{ denied: gameManager.stateManager.permissions && !gameManager.stateManager.permissions.level }">
  @if (!gameManager.bbRules()) {
    <div class="menu">
      @if (gameManager.game.playerCount < 1) {
        <label class="checkbox">
          <input
            tabclick
            type="checkbox"
            [checked]="gameManager.game.levelCalculation"
            (change)="setLevelCalculation(!gameManager.game.levelCalculation)"
          />
          <span [ghs-label]="'settings.levelCalculation'"></span>
        </label>
      }
      @if (gameManager.game.levelCalculation) {
        <label>
          <span [ghs-label]="'settings.levelAdjustment'"></span>
          :&nbsp;
          <ghs-number-input
            [model]="gameManager.game.levelAdjustment"
            (modelChange)="setLevelAdjustment($event)"
            [min]="-6"
            [max]="6"
          ></ghs-number-input>
        </label>
      }
      <label>
        <span [ghs-label]="'settings.bonusAdjustment'"></span>
        :&nbsp;
        <ghs-number-input
          [model]="gameManager.game.bonusAdjustment"
          (modelChange)="setBonusAdjustment($event)"
          [min]="-6"
          [max]="6"
        ></ghs-number-input>
      </label>
      @if (ge5Player()) {
        <label class="checkbox">
          <input tabclick type="checkbox" [checked]="gameManager.game.ge5Player" (change)="setGe5Player(!gameManager.game.ge5Player)" />
          <span [ghs-label]="'settings.ge5Player'"></span>
        </label>
        @if (gameManager.game.ge5Player) {
          <label class="checkbox capped">
            <input
              tabclick
              type="checkbox"
              [checked]="gameManager.game.ge5PlayerCapped"
              (change)="setGe5PlayerCapped(!gameManager.game.ge5PlayerCapped)"
            />
            <span [ghs-label]="'settings.ge5Player.capped'"></span>
          </label>
        }
      }
    </div>
    <div class="level-container" [ngClass]="{ disabled: gameManager.game.levelCalculation }">
      <span class="item"><img src="./assets/images/level.svg" /></span>
      @for (level of levels; track level) {
        <span class="item">
          @if (!gameManager.game.levelCalculation) {
            <a
              tabclick
              class="level"
              [ngClass]="{
                active: level === gameManager.game.level,
                scenariolevel: gameManager.game.playerCount < 1 && level === scenarioLevel
              }"
              (click)="setLevel(level)"
              >{{ level }}</a
            >
          }
          @if (gameManager.game.levelCalculation) {
            <a
              class="level"
              [ngClass]="{
                active: level === gameManager.game.level,
                scenariolevel: gameManager.game.playerCount < 1 && level === scenarioLevel
              }"
              >{{ level }}</a
            >
          }
        </span>
      }
      <div class="solo">
        <label class="checkbox">
          <input tabclick type="checkbox" [checked]="gameManager.game.solo" (change)="setSolo(!gameManager.game.solo)" />
          <span [ghs-label]="'game.solo'"></span>
        </label>
      </div>
    </div>
    <div class="values">
      <div class="loot">
        <span class="icon"
          ><img class="ghs-svg" [src]="'./assets/images' + (settingsManager.settings.fhStyle ? '/fh' : '') + '/loot.svg'" />:</span
        >
        <span class="value">x{{ loot }}</span>
        <span class="hint"
          ><span [ghs-label]="'game.level.loot'"></span>&nbsp;
          @if (wealthFavor) {
            <span [ghs-label]="'data.favors.fh.wealth.level'" [ghs-label-args]="[wealthFavor]"></span>
          }
        </span>
      </div>
      <div class="trap">
        <span class="icon"><img class="ghs-svg" src="./assets/images/trap.svg" />:</span>
        <span class="value">{{ trap }}</span>
        <span class="hint"><span [ghs-label]="'game.level.trap'"></span></span>
      </div>
      <div class="experience">
        <span class="icon"><img class="ghs-svg" src="./assets/images/experience.svg" />:</span>
        <span class="value">+{{ experience }}</span>
        <span class="hint"><span [ghs-label]="'game.level.experience'"></span></span>
      </div>
      <div class="terrain">
        <span class="icon"><img class="ghs-svg" src="./assets/images/terrain.svg" />:</span>
        <span class="value">{{ hazardousTerrain }}</span>
        <span class="hint"><span [ghs-label]="'game.level.hazardousTerrain'"></span></span>
      </div>
    </div>
    <label class="checkbox player-count">
      <input tabclick type="checkbox" [checked]="gameManager.game.playerCount > 0" (change)="togglePlayerCount($event)" />
      <span [ghs-label]="'settings.playerCount'"></span>
      @if (gameManager.game.playerCount > 0) {
        <input
          tabclick
          type="number"
          #playerCount
          [value]="gameManager.game.playerCount"
          min="1"
          (keyup)="(0)"
          (change)="setPlayerCount(+playerCount.value)"
          [size]="playerCount.value.length"
          [ghs-label]="'settings.playerCount'"
          [ghs-label-attribute]="'placeholder'"
        />
      }
    </label>
  }
  @if (gameManager.bbRules()) {
    <div class="bb">
      <span class="title"
        ><img class="ghs-svg" src="./assets/images/bb/monster.svg" /><span [ghs-label]="'game.level.bb.monsterDifficulty'"></span>:</span
      >
      @for (level of [] | ghsRange: 5; track level) {
        <span class="level" [ngClass]="{ current: gameManager.game.levelAdjustment + 2 === level }" (click)="setBbMonsterDifficutly(level)">
          <span
            class="scenario-level"
            [ngClass]="{ 'level-1': level === 0, 'level-2': level === 1, 'level-3': level === 3, 'level-4': level === 4 }"
            [ghs-label]="'game.level.bb.monsterDifficulty.' + level"
          ></span>
          @if (gameManager.game.levelAdjustment + 2 === level) {
            <img class="ghs-svg" src="./assets/images/check.svg" />
          }
        </span>
      }
    </div>
  }
</div>
